import Select from "react-select";
import YEAR_OPTIONS from "../../../common/utils/yearOptions";
import MONTH_OPTIONS from "../../../common/resources/monthOptions.json";
import React from "react";
import { setBreadCrumb } from "../../../veritas/breadcrumb/BreadcrumbActions";
import { connect } from "react-redux";
import Header from "../../../common/components/Header";
import {Button, Confirm, Divider, Grid, Message} from "semantic-ui-react";
import Sidebar from "../../../common/components/Sidebar";
import BillingSidebarButtons from "../../shared/BillingSidebarButtons";
import Breadcrumb from "../../../common/partials/Breadcrumb/Breadcrumb";
import lodash from "lodash";
import {
    getBillingReport,
    uploadSapFile,
    getSapFileUploadStatus,
    getSapInputFile,
    getSapUsageControlFile,
    hideDownloadResponseMessage,
    hideRunResponseMessage,
    runBillingReport,
    runPricing,
    toggleSapUploadWarning,
    unmountBillingReportComponent,
    updateLinks,
    monthlyRollup
} from "../actions/BillingReportActions";
import {store} from "../../../store";
import LastUpdated from "../../../common/partials/LastUpdated";

export class BillingReportPage extends React.Component {

    state = {
        selectedYear: {label: "", value: 0},
        selectedMonth: {label: "", value: 0},
        availableMonths: MONTH_OPTIONS,
    }

    componentDidMount() {
        document.title = `Billing - Reports`;

        const today = new Date();
        let month = lodash.find(MONTH_OPTIONS, { value: Number(today.getMonth() + 1) }); // starts at 0 so +1
        let year = lodash.find(YEAR_OPTIONS, { value: Number(today.getFullYear())});

        // if January, default to December of previous year
        if (month.value === 1) {
            year = lodash.find(YEAR_OPTIONS, { value: Number(today.getFullYear()) - 1});
            month = lodash.find(MONTH_OPTIONS, { value: 12 });
        }

        this.setState({
            selectedYear: {label: year.label, value: year.value},
            selectedMonth: {label: month.label, value: month.value},
            availableMonths: lodash.filter(MONTH_OPTIONS, m => m.value <= month.value + 1)
        }, this.updateSapUploadStatus);

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/reports', text: 'Billing Reports' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        });
    }

    componentWillUnmount = () => {
        this.props.unmountBillingReportPage();
    }

    handleUpdateLinksClick = () => {
        this.props.updateLinks();
    }

    handleMonthlyRollupClick = () => {
        this.props.monthlyRollup(this.formattedSelectedDate);
    }

    handleRunBillingReportClick = () => {
        this.props.runBReport(this.formattedSelectedDate);
    }

    handleRunPricingClick = () => {
        this.props.runPricing(this.formattedSelectedDate);
    }

    handleGetBillingReportClick = () => {
        this.props.getBReport(this.formattedSelectedDate);
    }

    handleGetSapInputFileClick = () => {
        this.props.getSapInputFile(this.formattedSelectedDate, this.props.sapFileUploadData.entropy);
    }

    handleGetSapUsageControlFileClick = () => {
        this.props.getSapUsageControlFile(this.formattedSelectedDate, this.props.sapFileUploadData.entropy);
    }

    get formattedSelectedDate() {
        return this.state.selectedYear.value + "-"
            + String("0" + this.state.selectedMonth.value).slice(-2)
            + "-01";
    }

    formatSelectedDate = (selectedYear, selectedMonth) => {
        return selectedYear.value + "-"
            + String("0" + selectedMonth.value).slice(-2)
            + "-01";
    }

    updateSapUploadStatus() {
        this.props.getSapFileUploadStatus(
            this.formatSelectedDate(this.state.selectedYear, this.state.selectedMonth));
    }

    handleSelectYear = (filterOption) => {
        const year = new Date().getFullYear();
        const month = new Date().getMonth() + 1;
        if (filterOption != null && filterOption.value < year) {
            this.setState(prevState => ({
                selectedYear: filterOption,
                availableMonths: MONTH_OPTIONS
            }), this.updateSapUploadStatus);
        } else {
            this.setState(prevState => ({
                selectedYear: filterOption,
                availableMonths: lodash.filter(MONTH_OPTIONS, m => m.value <= month)
            }), this.updateSapUploadStatus);
        }
    }

    handleSelectMonth = (filterOption) => {
        this.setState(prevState => ({
            selectedMonth: filterOption
        }), this.updateSapUploadStatus);
    }

    handleDownloadMessageDismiss = () => {
        store.dispatch(hideDownloadResponseMessage());
    }

    handleRunMessageDismiss = () => {
        store.dispatch(hideRunResponseMessage());
    }

    handleToggleUploadSapClick = () => {
        this.props.toggleSapUploadWarning();
    }

    handleConfirmUploadSapClick = () => {
        this.props.uploadSapFile(this.formattedSelectedDate);
        this.props.toggleSapUploadWarning();
    }

    get rangeSelectionContent() {
        const { showDownloadMessage, downloadMessageData, showDbSpinner, sapFileUploadData } = this.props;
        const { selectedMonth, selectedYear, availableMonths } = this.state;
        return (
            <div>
                <div>
                    <p>Please Select the Year and Month to retrieve the Billing Reports.</p>
                    <div className={"records-range-selection"}>
                        <Select
                            styles={{
                                menu: provided => ({ ...provided, zIndex: 9999 })
                            }}
                            onChange={this.handleSelectYear}
                            options={YEAR_OPTIONS}
                            placeholder={"Select A Year"}
                            isSearchable={true}
                            getOptionLabel={option => option.label}
                            getOptionValue={option => option.value}
                            value={selectedYear}
                        />
                        <Select
                            styles={{
                                menu: provided => ({ ...provided, zIndex: 9999 })
                            }}
                            onChange={this.handleSelectMonth}
                            options={availableMonths}
                            placeholder={"Select A Month"}
                            isSearchable={true}
                            value={selectedMonth}
                        />
                        <Button
                            className={showDbSpinner ? "loading" : ""}
                            style={{marginLeft: '20px'}}
                            content={"Download Billing Report"}
                            color={"blue"}
                            onClick={this.handleGetBillingReportClick}
                        />
                        {Object.keys(sapFileUploadData).length === 0 ?
                            <Button
                                className={this.props.showDsSpinner ? "loading" : ""}
                                style={{marginLeft: '10px'}}
                                content={"Upload to SAP"}
                                color={"blue"}
                                onClick={this.handleToggleUploadSapClick}
                            />
                            : null
                        }
                        {Object.keys(sapFileUploadData).length > 0 ?
                            (<>
                                <Button
                                    style={{marginLeft: '10px'}}
                                    content={"Download SAP Input File"}
                                    color={"blue"}
                                    onClick={this.handleGetSapInputFileClick}
                                />
                                <Button
                                    style={{marginLeft: '10px'}}
                                    content={"Download SAP Usage Control File"}
                                    color={"blue"}
                                    onClick={this.handleGetSapUsageControlFileClick}
                                />
                            </>)
                            : null
                        }

                    </div>
                    <div>
                        {Object.keys(sapFileUploadData).length > 0
                            ? (<div style={{margin: "auto"}}>
                                <i>SAP file uploaded on
                                    <LastUpdated lastUpdated={sapFileUploadData.time_uploaded} type={"medium"} />
                                </i>
                            </div>)
                            : null}
                    </div>
                </div>
                {showDownloadMessage ? (
                    <div>
                        {downloadMessageData.status === "ERROR" ?
                            <Message
                                error
                                onDismiss={this.handleDownloadMessageDismiss}
                                header="Error"
                                content={downloadMessageData.message}
                            /> :
                            <Message
                                success
                                onDismiss={this.handleDownloadMessageDismiss}
                                header="Success"
                                content="Please find the file(s) in your downloads"
                            />
                        }
                    </div>
                ) : null}
            </div>
        )
    }

    get advancedOptionsButtons() {
        const { showRunMessage, runMessageData, showUlSpinner, showMrSpinner, showRpSpinner, showRbSpinner, sapFileUploadData } = this.props;
        return (
          <div>
              <Divider></Divider>
                  <div className="ui info message">
                      <p>
                          Run Pricing only needs to be clicked if pricing was changed after month end and the billing report
                          needs to be updated. In that instance, you would need to Run Pricing and then Run Billing.
                      </p>
                      <p>
                          Run Billing will need to be clicked if there are any manual billing entries in the month or if Run
                          Pricing was clicked.
                      </p>
                      <p>
                          Once the Billing Report for a month has been uploaded to SAP, Run Pricing and Run Billing will no
                          longer be available.
                      </p>
                  </div>
                  <div style={{marginBottom: '20px'}}>
                      <Button
                          disabled={Object.keys(sapFileUploadData).length > 0}
                          className={showUlSpinner ? "loading" : ""}
                          content={"Update Links"}
                          onClick={this.handleUpdateLinksClick}
                      />
                      <Button
                          disabled={Object.keys(sapFileUploadData).length > 0}
                          className={showMrSpinner ? "loading" : ""}
                          style={{marginLeft: '10px'}}
                          content={"Rollup Monthly"}
                          onClick={this.handleMonthlyRollupClick}
                      />
                      <Button
                          disabled={Object.keys(sapFileUploadData).length > 0}
                          className={showRpSpinner ? "loading" : ""}
                          style={{marginLeft: '10px'}}
                          content={"Run Pricing"}
                          onClick={this.handleRunPricingClick}
                      />
                      <Button
                          disabled={Object.keys(sapFileUploadData).length > 0}
                          className={showRbSpinner ? "loading" : ""}
                          style={{marginLeft: '10px'}}
                          content={"Run Billing"}
                          onClick={this.handleRunBillingReportClick}
                      />
                  </div>
                  {showRunMessage ? (
                      <div>
                          {runMessageData.status === "ERROR" ?
                              <Message
                                  error
                                  onDismiss={this.handleRunMessageDismiss}
                                  header="Error"
                                  content={runMessageData.message}
                              /> :
                              <Message
                                  success
                                  onDismiss={this.handleRunMessageDismiss}
                                  header="Success"
                                  content={"Updated " + runMessageData.records + " records"}
                              />
                          }
                      </div>
                  ) : null}
          </div>
        )
    }

    get pageContent() {

        return(
            <div className={"manual-entry-records-page"}>
                <div className="ui segments">
                    <div className="ui segment">
                        <h3>Billing Reports</h3>
                    </div>
                    <div className="ui segment">
                        {this.rangeSelectionContent}
                        {this.advancedOptionsButtons}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { uploadSapWarning } = this.props;
        const { selectedMonth, selectedYear } = this.state;

        const uploadToSAPText = `This button will create the billing files and send them to the SAP system for
        ${selectedMonth.label} ${selectedYear.value}. Only one file can be sent per month and this action cannot be
        undone. After the upload is complete, you will have the option to download the SAP Usage Control File and
        SAP Input File to your computer.`;

        return (
            <div className="billing">
                <Header />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <BillingSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={12}>
                        <Breadcrumb />
                        {this.pageContent}
                    </Grid.Column>
                </Grid>

                <Confirm
                    open={uploadSapWarning}
                    confirmButton={"Upload to SAP"}
                    content={uploadToSAPText}
                    onCancel={this.handleToggleUploadSapClick}
                    onConfirm={this.handleConfirmUploadSapClick}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isBillingAdmin: state.marvel.user.access.accessLevel.isBillingAdmin,
    showRunMessage: state.billing.billingReportReducer.showRunMessage,
    showDownloadMessage: state.billing.billingReportReducer.showDownloadMessage,
    runMessageData: state.billing.billingReportReducer.runMessageData,
    downloadMessageData: state.billing.billingReportReducer.downloadMessageData,
    showUlSpinner: state.billing.billingReportReducer.showUlSpinner,
    showMrSpinner: state.billing.billingReportReducer.showMrSpinner,
    showRpSpinner: state.billing.billingReportReducer.showRpSpinner,
    showRbSpinner: state.billing.billingReportReducer.showRbSpinner,
    showDbSpinner: state.billing.billingReportReducer.showDbSpinner,
    showDsSpinner: state.billing.billingReportReducer.showDsSpinner,
    sapFileUploadData: state.billing.billingReportReducer.sapFileUploadData,
    uploadSapWarning: state.billing.billingReportReducer.uploadSapWarning,
});

const mapDispatchToProps = dispatch => ({
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
    unmountBillingReportPage: () => { dispatch(unmountBillingReportComponent()) },
    updateLinks: () => { dispatch(updateLinks()) },
    monthlyRollup: (date) => { dispatch(monthlyRollup(date)); },
    runBReport: (date) => { dispatch(runBillingReport(date)) },
    runPricing: (date) => { dispatch(runPricing(date)) },
    getBReport: (date) => { dispatch(getBillingReport(date)) },
    uploadSapFile: (date) => { dispatch(uploadSapFile(date)) },
    getSapInputFile: (date, entropy) => { dispatch(getSapInputFile(date, entropy)) },
    getSapUsageControlFile: (date, entropy) => { dispatch(getSapUsageControlFile(date, entropy)) },
    getSapFileUploadStatus: (date) => { dispatch(getSapFileUploadStatus(date)) },
    toggleSapUploadWarning: () => { dispatch(toggleSapUploadWarning()) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingReportPage)

